module.exports = __webpack_public_path__ + "static/media/shape-divider.6172d5d1.png";